var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{'tabpane-view': true, 'active': _vm.active},on:{"click":function($event){_vm.active ? '' :  _vm.$emit('click')}}},[_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }